exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-box[data-v-09395bdc]{height:600px;text-align:center}.section-box>div[data-v-09395bdc]{margin-bottom:20px}.slogn[data-v-09395bdc]{text-align:center;font-size:0}.slogn .logo-box[data-v-09395bdc]{margin:10px auto;width:200px;margin-bottom:20px}.slogn img[data-v-09395bdc]{width:100%}.slogn h3[data-v-09395bdc],.slogn span[data-v-09395bdc]{display:inline-block;vertical-align:middle;line-height:1;font-size:22px}.desc[data-v-09395bdc]{margin-top:10px;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-09395bdc","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/www/newcode/platform-admin/src/style/theme.scss","/data/www/newcode/platform-admin/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/base/asset/accountactivation/index.vue
// module id = 851
// module chunks = 30